import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { EventPageHeaderContent } from 'src/modules/events/components/EventPage/EventPageHeaderSection/EventPageHeaderContent';
import { media } from 'src/styles/designs';
import { DirectusImage } from 'src/components/common/DirectusImage';
import { casePathEmptyString } from 'src/utils/casePathEmptyString';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';
import { useRectMeasure } from 'src/hooks/useRectMeasure';
import { dirRTL } from 'src/styles/theme';
import { EventPageStickyMenu } from 'src/modules/events/components/EventPage/EventPageStickyMenu';

const Header = styled.header<{ $background?: string; $short: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 404px;
  background: ${({ theme, $background }) =>
    $background ?? theme.palette.accent};

  ${media.w.greaterThanOrEqual.desktop} {
    min-height: 528px;
    ${ConstraintContainer} {
      max-width: 1100px;
    }
  }
  ${casePathEmptyString('$short')(
    css`
      min-height: 235px !important;
      padding-bottom: 12px;
      ${media.w.greaterThanOrEqual.desktop} {
        padding-bottom: 30px;
      }
    `,
  )}
`;

const Container = styled(ConstraintContainer)`
  max-width: 1100px;
  flex: 1;
  display: flex;
`;

const BackgroundImage = styled(DirectusImage)`
  object-fit: cover;
  object-position: 20% top;
  overflow: visible;

  ${media.w.greaterThanOrEqual.desktop} {
    object-fit: contain;
    object-position: 70% center;
    ${dirRTL} {
      object-position: 0% center;
    }
  }
  ${media.w.lessThan.desktop} {
    right: -30vw !important;
  }
`;

export const EventPageHeaderSection = () => {
  const [bannerRef, height] = useRectMeasure();
  const { event, isNow, isCompleted } = useContext(EventPageContext);

  const backgroundImage = event.image ?? event.type?.image;

  return (
    <Header
      ref={bannerRef}
      $short={isNow || isCompleted}
      $background={event.background ?? event.type?.background}
    >
      <EventPageStickyMenu event={event} bannerHeight={height} />
      <Container>
        {backgroundImage && (
          <BackgroundImage src={backgroundImage.id} layout="fill" />
        )}
        <EventPageHeaderContent />
      </Container>
    </Header>
  );
};
